"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function line(ctx, l) {
    ctx.beginPath();
    ctx.moveTo(l.from.x, l.from.y);
    ctx.lineTo(l.to.x, l.to.y);
    ctx.stroke();
}
exports.line = line;
function lineControlPoints(ctx, l) { }
exports.lineControlPoints = lineControlPoints;
function calcLineControlPoints(l) {
    l.controlPoints = [];
}
exports.calcLineControlPoints = calcLineControlPoints;
//# sourceMappingURL=line.js.map